export default "__VITE_ASSET__D05j$NRe__$_?no-inline__"